import { Button } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const RedeemButton = Button.withConfig({
  variant: 'solid',
  backgroundColor: primitive.bk.$meltyYellow,
  textDecorationColor: primitive.bk.$meltyYellow,
  _hover: {
    backgroundColor: primitive.bk.$meltyYellowDark45,
  },
  _pressed: {
    backgroundColor: primitive.bk.$meltyYellowDark40,
  },

  height: '$7.5',
  size: 'sm',
  _text: {
    variant: 'copyTwo',
    fontSize: 'xs',
    lineHeight: 'xs',
    color: primitive.bk.$bbqBrown,
  },
});
